import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSupplierInfo } from '../../../../store/slices/supplierInfoSlice';
import { getFormattedDate } from '../../../../utils/method';
import InfoRow from './InfoRow';
import InfoSection from './InfoSection';

const PerformancePeriodSection = () => {
    const { t } = useTranslation();
    const supplierInfo = useSelector(selectSupplierInfo);
    const invoice = supplierInfo?.invoice || {};

    return (
        <InfoSection>
            <InfoRow
                label={t('supplier-info.performance-period-until')}
                value={`${getFormattedDate(invoice?.billingPeriodFrom ?? '')} - ${getFormattedDate(invoice?.billingPeriodTo ?? '')}`}
                isEditable={false}
                equalColumns
            />
            <InfoRow
                label={t('supplier-info.invoice-number')}
                value={invoice?.invoiceNumber ?? ''}
                isEditable={false}
            />
            <InfoRow
                label={t('supplier-info.internal-reference-number')}
                value={invoice?.internalReferenceNumber ?? ''}
                isEditable={false}
            />
            <InfoRow
                label={t('supplier-info.invoice-date')}
                value={getFormattedDate(invoice?.invoiceDate ?? '')}
                isEditable={false}
            />
            <InfoRow
                label={t('supplier-info.order-number')}
                value={invoice?.orderNumber ?? ''}
                isEditable={false}
            />
            <InfoRow
                label={t('supplier-info.order-date')}
                value={getFormattedDate(invoice?.orderDate ?? '')}
                isEditable={false}
            />
            {invoice?.cashDiscountDate && (
                <>
                    <InfoRow
                        label={t('supplier-info.invoice-arrival-date')}
                        value={getFormattedDate(invoice?.invoiceArrivalDate ?? '')}
                        isEditable={false}
                    />
                    <InfoRow
                        label={t('supplier-info.cash-discount-date')}
                        value={getFormattedDate(invoice?.cashDiscountDate ?? '')}
                        isEditable={false}
                    />
                </>
            )}
        </InfoSection>
    );
};

export default PerformancePeriodSection;
